import { app } from '../../bootstrap/core';
import { transferringState, receivingState } from './tickets.state';
import { TicketsService } from './tickets.service';
import './ticketOverview/ticketOverview';
import './chart/chart';
import './create/receiving/receiving';
import './create/transferring/transferring';

app.config(receivingState);
app.config(transferringState);
app.service('ticketsService', TicketsService);
